import SEO from '../components/SEO';

export default function AgeSuitabilityPage() {
  return (
    <div className="flex-1 bg-white py-12">
      <SEO
        title="Age Suitability | Waybook"
        description="Learn about Waybook's age requirements and parental guidance recommendations for young travelers."
        keywords="age suitability, minimum age, parental guidance, youth safety"
        canonicalUrl="https://www.waybook.me/age-suitability"
        structuredData={{
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: 'Age Suitability',
          description: 'Age requirements and parental guidance for Waybook',
          url: 'https://www.waybook.me/age-suitability'
        }}
      />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl font-bold mb-8">Age Suitability</h1>
        
        <div className="prose max-w-none space-y-8">
          <section>
            <h2 className="text-2xl font-semibold mb-4">Minimum Age</h2>
            <p className="text-gray-700">
              Waybook is designed for users aged 13 and older. If you are under the age of
              18 (or the age of majority in your jurisdiction), you should use Waybook with
              the involvement of a parent or guardian.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">Parental Guidance</h2>
            <p className="text-gray-700">
              Parents and guardians should review and supervise how minors use the app,
              including privacy settings, sharing options, and any user‑generated content.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">Content & Interactions</h2>
            <p className="text-gray-700">
              We aim to provide a safe, travel‑focused experience. Users should not post
              or share content that is inappropriate for persons aged 13+. Report issues via
              in‑app tools or the email below.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">Children’s Privacy</h2>
            <p className="text-gray-700">
              We do not knowingly collect personal information from children under 13. If
              you believe we have collected such information, please contact us and we will
              take steps to delete it.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-2">Report a Concern</h2>
            <p className="text-gray-700">Email: <a href="mailto:safety@waybook.me">safety@waybook.me</a></p>
          </section>
        </div>
      </div>
    </div>
  );
}
